import { TFunction, useTranslation } from 'next-i18next'
import Router from 'next/router'
import React from 'react'
import { connect } from 'react-redux'

import BlockModal from '../../../components/Profiles/BlockModal'
import { report } from '../../../modules/entities/actions/report'
import { redirectAs } from '../../../modules/routing/actions'
import TextButton from '../../../ui/buttons/text'
import { TextLink } from '../../../ui/link'
import Trigger from '../../../ui/Trigger'
import { applySubstitutions, link_for_resource } from '../../../url'
import ReportModalContainer from './ReportModal'

export type Props = {
  t: TFunction
  resourceType: any
  parentRoute: string
  currentUser: any
  resource: any
  parent: any
  params: any
  sendReport: Function
  closeModal: Function
}

const stateToProps = (state: any, { params, resourceType }: any) => ({})

const dispatchToProps = (dispatch: Function, props: Props): any => ({
  sendReport(resource: any, message: string): void {
    dispatch(report(resource, message))
  },
  closeModal(): void {
    dispatch(
      redirectAs(
        props.parentRoute,
        applySubstitutions(props.parentRoute, Router.query)
      )
    )
  },
})

export const ReportModal = connect(
  stateToProps,
  dispatchToProps
)(ReportModalContainer)

export const ReportMessage = ({ resource }) => {
  const { t } = useTranslation('common')
  return (
    <p className="report-a-problem fs-unmask">
      {t(`report_problem.${resource.type}_explanation`)}
      <span> </span>
      <TextLink to={link_for_resource(resource, 'report')}>
        {t(`report_problem.report_${resource.type}_link_text`)}
      </TextLink>
      {resource.type === 'user' ? (
        <>
          <Trigger
            renderTrigger={open => (
              <span style={{ display: 'block', marginTop: '0.5em' }}>
                <TextButton onClick={open}>
                  {t(`report_problem.block_${resource.type}_link_text`)}
                </TextButton>
              </span>
            )}
            renderContent={close => (
              <BlockModal user={resource} onClose={close} />
            )}
          />
        </>
      ) : null}
    </p>
  )
}
